import HangManGame from "./HangManGame";
export default HangManGame;